import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AbstractItemComponent } from '@df/catalog-ui/abstract-item.component';
import { IPageDataV2, IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsPage } from '@icms/core/resource/page/icms-page';
import { LocalPage } from 'projects/app-default/src/app/catalog/page/local/local-page';
import { NBlogCategoryPageType } from '../../../page/category-view/cms-blog-page-category-view.component';
import { NBlogPostPageType } from '../../../page/post-view/cms-blog-post.namespace';

@Component({
    standalone: true,
    imports: [DfModuleImageModule, RouterLink, TranslationModule],
    selector: 'cms-blog-component-more-stories-item',
    templateUrl: './cms-blog-component-more-stories-item.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsBlogComponentMoreStoriesItemComponent extends AbstractItemComponent<LocalPage<IPageDataV3<NBlogPostPageType.ITypeData>>> {
    type = ICmsPage.type;
    protected tagCategories: LocalPage<IPageDataV2<NBlogCategoryPageType.ITypeData>>[] = [];

    protected override onModelChange(): void {
        this.tagCategories =
            (this.model as LocalPage<IPageDataV3<NBlogPostPageType.ITypeData>>)?.getBlogPostCategories()?.slice(0, 3) || [];
        super.onModelChange();
    }

    get typeData() {
        return this.model?.data?.typeData;
    }
}
